export enum CONTRACT_SUPPLIER_STATUSES {
    ACTIVE = 'ACTIVE',
    DECLINED = 'DECLINED',
    DRAFT = 'DRAFT'
}
